import React from 'react'
import './css/newssection.css'
import { Link } from 'react-router-dom'
import { ChevronsRight} from "lucide-react";
export default function Newssection() {
  return (
    <>
    <div className='header-containerr'>
    <header className='header-name'>
        <h1>Industry News</h1>
        <div>
          <ChevronsRight color="black" size={24} />
        </div>
    </header>
    </div>
    <div className="container" id='green' >
  {/* Main Article */}
  <article className="main-article" id='orange'>
    <div className="grid-layout">
      {/* Main Content */}
      <div className="main-content">
        {/* Featured Article */}
        <div className="featured-article">
          <Link to="/healthcare1">
          <img
            src="./images/irans-suprem.jpg"
            alt="Business people in a hallway"
            className="featured-image"
          />
          </Link>
          <Link to="/healthcare1" className='anchor'>
          <h1>
          Iran’s Supreme Leader Threatens Israel and U.S. With ‘a Crushing Response’ Over Israeli Attack
          </h1>
          </Link>
          
          <div className="author-info">
            
            <span>By Kelly Phillips Erb</span>
            <span className="separator">|</span>
            <span>TSD Staff</span>
            
          </div>
        </div>
        {/* Secondary Articles Grid */}
        <div className="secondary-articles">
          {/* Article 1 */}
          <div className="article">
            <Link to="/healthcare2">
            <img
              src="./images/musk-cash.jpg"
             
            />
            </Link>
            <Link to="/healthcare2" className='anchor'>
            <h2>
            Musk election cash giveaways can continue as judge mulls case
            </h2>
            </Link>
            <div className="author-info">
              By Kelly Phillips Erb | TSD Staff
            </div>
            
          </div>
          {/* Article 2 */}
          <div className="article">
            <Link to="/healthcare3">
            <img
              src="./images/Fatah-Hamas.jpg"
              
            />
            </Link>
            <Link to="/healthcare3" className='anchor'>
            <h2>
            Fatah-Hamas Reconciliation Progress
            </h2>
            </Link>
            
            
            <div className="author-info">By Hank Tucker | TSD Staff</div>
            
          </div>
        </div>
      </div>
      {/* Sidebar */}
      <aside className="sidebar">
        {/* Sidebar Article 1 */}
        <div className="sidebar-article">
          <Link to="/healthcare4">
          <img
            src="./images/Syria.jpg"
            alt="Tax document review"
          />
          </Link>
          <Link to="/healthcare4" className='anchor'>
          <h2>Syrian Conflict Escalation</h2>
          </Link>
          <div className="author-info">By Steve Forbes | TSD Staff</div>
        </div>
        {/* Sidebar Article 2 */}
        <div className="sidebar-article">
          <Link to="/healthcare5">
          <img
            src="./images/India-Israel.jpg"
            alt="Small business owner"
          />
          </Link>
          <Link to="/healthcare5" className='anchor'>
          <h2>
          India Reaffirms Palestinian Support
          </h2>
          </Link>
          
          <div className="author-info">By Brandon Kochkodin | TSD Staff</div>
        </div>
      </aside>
    </div>
    <header className="site-header">
    <h1></h1>
    <Link to="#" className="link-more">
      Load More »»
    </Link>
  </header>
  </article>
  
</div>

</>



  )
}
